// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dad884e9","453":"5c5e9e30","455":"be26f542","977":"85072650"}[chunkId] + ".chunk.js";
};